import type { Theme } from "@mui/material";
import { Car, House, Image, ShoppingCart } from "lucide-react";
import {
	ClientPortfolioDomainEnum,
	ClientPropertyTypeEnum,
} from "web_myplann/Infrastructure/Api/Api";

const getIconColor = (theme: Theme) =>
	theme.palette.mode === "dark"
		? theme.palette.grey[300]
		: theme.palette.grey[500];

export const getPortfolioIcon = (
	theme: Theme,
	propertyType?: ClientPropertyTypeEnum | null | undefined,
	portfolioType?: ClientPortfolioDomainEnum | null | undefined,
): React.ReactNode => {
	const iconColor = getIconColor(theme);

	switch (propertyType) {
		case ClientPropertyTypeEnum.AutoMoto:
			return <Car size={48} color={iconColor} />;
		case ClientPropertyTypeEnum.Art:
			return <Image size={48} color={iconColor} />;
		case ClientPropertyTypeEnum.Cottage:
		case ClientPropertyTypeEnum.House:
		case ClientPropertyTypeEnum.Land:
		case ClientPropertyTypeEnum.Flat:
			return <House size={48} color={iconColor} />;
	}

	switch (portfolioType) {
		case ClientPortfolioDomainEnum.Services:
		case ClientPortfolioDomainEnum.PaidAdvisory:
			return <ShoppingCart size={48} color={iconColor} />;
		default:
			return null;
	}
};
